import { useContext } from 'react'
import { ToastContext } from '../../contexts/toast/provider'

export const useToast = () => useContext(ToastContext)
